import BrandFilter from './BrandFilter';
import PriceFilter from './PriceFilter';
import ProductTypeFilter from './ProductTypeFilter';
import ReviewFilter from './ReviewFilter';
import ConditionsFilter from './ConditionsFilter';
import TreatmentFormFilter from './TreatmentFormFilter';
import DrugClassFilter from './DrugClassFilter';
import ActiveIngredientFilter from './ActiveIngredientFilter';
import { FilterMethods } from '../../../../modules/sortAndFilter/config/SortAndFilterConfig';

type MapValues =
    | BrandFilter
    | ConditionsFilter
    | TreatmentFormFilter
    | DrugClassFilter
    | ReviewFilter
    | ActiveIngredientFilter
    | PriceFilter
    | ProductTypeFilter;

const createFilters = (urlKey: string) => {
    const brandFilter = new BrandFilter('brand', urlKey);
    const conditionsFilter = new ConditionsFilter('conditions', urlKey);
    const treatmentFormFilter = new TreatmentFormFilter('treatmentForm', urlKey);
    const drugClassFilter = new DrugClassFilter('drugClass', urlKey);
    const reviewFilter = new ReviewFilter('review', urlKey);
    const activeIngredientFilter = new ActiveIngredientFilter('activeIngredient', urlKey);
    const priceFilter = new PriceFilter('price', urlKey);
    const productTypeFilter = new ProductTypeFilter('productType', urlKey);

    // TODO: Change string to FilterTypes['type'] when correct names have been updated.
    return new Map<FilterMethods, MapValues>([
        ['brand', brandFilter],
        ['conditions', conditionsFilter],
        ['treatmentForm', treatmentFormFilter],
        ['drugClass', drugClassFilter],
        ['review', reviewFilter],
        ['activeIngredient', activeIngredientFilter],
        ['price', priceFilter],
        ['productType', productTypeFilter],
    ]);
};

export default createFilters;
